import { graphql, useStaticQuery } from "gatsby";
import useLocalizedData from "../i18n/use-localized-data";

export const GetContact = () => {
  const siteData = useStaticQuery(graphql`
    query getAllContact {
      allStrapiHomePage {
        nodes {
          locale
          ContactSection {
            Etage
            PLZ
            Street
            TeaserText {
              children {
                text
                italic
              }
            }
            email
          }
        }
      }
    }
  `);
  return useLocalizedData(siteData.allStrapiHomePage);
};
